<style>
  .PersonImgUl {
    position: absolute;
    width: 25px;
    height: 35px;
    transition: all 2s ease;

  }

  .PersonImgUl:hover {
    width: 75px;
    height: 100px;
    z-index: 50;
  }

  .MySecondDiv {
    width: 100%;
    transition: all 1.5s ease;
  }

  .MyFirstDiv {
    width: 0%;
    transition: all 1.5s ease;


  }



  .MyMainDiv:hover>.MyFirstDiv {
    width: 20%;
  }

  .MyMainDiv:hover>.MySecondDiv {
    width: 80%;
    padding-right: 5px;
  }
</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <br />

      <br>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-file highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">تعداد رسید باز</p>
                  <h4>{{openCalibration}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-file highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> حکم‌های رسید نشده </p>
                  <h4>{{mission}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-file highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> گواهی نامه منتظر بارگذاری </p>
                  <h4>{{certificate}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>



      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>

      <br>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input [(ngModel)]="Filter_customer" name="Filter_customer" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> شماره رسید </label>
          <input [(ngModel)]="Filter_code" name="Filter_code" type="number" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> شماره حکم </label>
          <input [(ngModel)]="Filter_Schdedule" name="Filter_Schdedule" type="number" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <br>
      <br>

      <br />
      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Calibration(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" (click)="OnBack_Calibration_Action_List(0)" type="button" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> حکم های رسید نشده </button>
          <button *ngIf="!Procssing" type="button" (click)="openModalExit(templateExit)" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa fa-wpforms"></i> کد تایید لغو ماموریت</button>
          <button *ngIf="Procssing" type="button" class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید ... <i
              class="fa fa-spin fa-spinner"></i> </button>
        </div>
      </div>

      <br />

      <div class="row">

        <div class="col-md-6 mb-30 " *ngFor="let item of DataList_Calibration">

          <div class="card h-100">
            <div class="card-body">

              <div class="row MyMainDiv" style="padding: 5px;">
                <div class="MyFirstDiv">
                  <img src="{{BaserUrlImage}}{{item.username_img}}" title="{{item.username}}"
                    style="width: 100%;height: 100%;" />
                </div>
                <div class="MySecondDiv">

                  <div style="float: right;">
                    <h5 style="font-weight: 600;"> نامه شماره '{{item.code2}}' <span
                        *ngIf="item.canFunds">(سرپرست)</span> </h5>
                    <h5 style="font-weight: 600;"> تاریخ (ها) حکم '{{item.scheduleDate}}' </h5>
                  </div>
                  <div style="float: left;">
                    <h6 style="font-weight: 600;"> شماره رسید '{{item.code}}' </h6>
                  </div>
                  <div style="clear: both;"></div>
                  <hr />
                  <h6 style="font-weight: 600;" style="cursor: pointer;text-decoration: underline;"
                    (click)="openModal_Customer(templateCustomer,item)"> {{item.customerName}} ({{item.customerCode}})
                  </h6>

                  <div class="row">

                    <div class="col-md-6">
                      <div *ngIf="item.funds>0" class="col-md-12 bg-success"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p><b>{{item.funds}}</b> هزینه ای ثبت شده </p>
                      </div>
                      <div *ngIf="item.funds==0" class="col-md-12 bg-danger"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p>هزینه ای ثبت نشده است </p>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div *ngIf="item.deviceCount[1]==0" class="col-md-12 bg-success"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p>همه دستگاه ها ثبت شدند </p>
                      </div>
                      <div *ngIf="item.deviceCount[1]==item.deviceCount[0]" class="col-md-12 bg-danger"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p>هیچ دستگاهی ثبت نشده است </p>
                      </div>
                      <div *ngIf="item.deviceCount[1]<item.deviceCount[0] && item.deviceCount[1]!=0"
                        class="col-md-12 bg-warning"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p>{{item.deviceCount[1]}} از {{item.deviceCount[0]}} دستگاه باقی مانده </p>
                      </div>
                    </div>
                  </div>

                  <div class="row" style="margin-top: 10px;">
                    <div class="col-md-6">
                      <div *ngIf="item.evalute>0" class="col-md-12 bg-success"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p> فرم ارزیابی ثبت شده است </p>
                      </div>
                      <div *ngIf="item.evalute==0" class="col-md-12 bg-danger"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p>فرم ارزیابی ثبت نشده است </p>
                      </div>

                    </div>

                    <div class="col-md-6">
                      <div *ngIf="item.uncertificate==0" class="col-md-12 bg-success"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p> گواهی نامه ها ثبت شده اند </p>
                      </div>
                      <div *ngIf="item.uncertificate>0" class="col-md-12 bg-danger"
                        style="height: 50px;color: white;line-height: 50px;text-align: center;">
                        <p> {{item.uncertificate}} دستگاه بدون گواهی نامه </p>
                      </div>

                    </div>
                  </div>


                  <hr>

                  <div *ngIf="item.status!='اتمام'">

                    <button (click)="OnBack_Calibration_Action_List(item.id,item.letterRequestSchduleCustomer_id)"
                      type="button" class="btn btn-info" style="margin-left: 5px;"> ادامه ثبت رسید </button>

                    <button *ngIf="item.canFunds" (click)="OnSet_Selected_Calibration_Record_Fund(item)" type="button"
                      class="btn btn-warning" style="margin-left: 5px;"> هزینه </button>

                    <button *ngIf="item.canFunds" (click)="OnSet_Selected_Calibration_Record_Evaluate(item)"
                      type="button" class="btn btn-success" style="margin-left: 5px;"> ازریابی کالیبراسون
                    </button>

                    <button *ngIf="item.uncertificate>0" (click)="OnSet_Selected_Calibration_Record_Certificate(item)"
                      type="button" class="btn btn-info" style="margin-left: 5px;"> ثبت
                      گواهی نامه </button>

                    <a target="_blank" href="{{BaseUrl}}{{item.letterRequestSchduleCustomer_id}}"
                      style="margin-left: 5px;" class="btn btn-danger"><i class="fa fa-file-pdf-o"></i> PDF</a>

                      <button (click)="openModal_LetterFile(templateLetterFile,item)" type="button"
                      class="btn btn-warning" style="margin-right: 5px;">
                      <i class="fa fa-file"></i> اطلاعات تکمیلی مشتری
                    </button>

                  </div>

                  <div *ngIf="item.status=='اتمام'">

                    <button *ngIf="item.uncertificate>0" (click)="OnSet_Selected_Calibration_Record_Certificate(item)"
                      type="button" class="btn btn-info" style="margin-left: 5px;"> ثبت
                      گواهی نامه </button>

                    <button *ngIf="item.canFunds" (click)="OnSet_Selected_Calibration_Record_Fund(item)" type="button"
                      class="btn btn-warning" style="margin-left: 5px;"> هزینه </button>


                    <button type="button" (click)="openModal_CalibrationStatus(templateCalibrationStatus,item)"
                      style="margin-left: 5px;" class="btn btn-warning"> فعال سازی رسید </button>

                    <button type="button" style="margin-left: 5px;" class="btn btn-danger"> حکم بسته شده است </button>

                  </div>
                  <!--
                  <p style="font-weight: 600;" *ngIf="item.evalute==0"> بررسی هزینه ها بعد از ارزیابی مشتری  </p>
                  <p style="font-weight: 600;" *ngIf="item.evalute>0 && item.uncertificate>0"> بررسی هزینه ها بعد از گواهی نامه‌ها  </p>
                  <p style="font-weight: 600;" *ngIf="item.evalute>0 && item.uncertificate==0 && item.deviceCount[1]>0"> بررسی هزینه ها بعد از ثبت کامل دستگاه‌ها  </p>
                    -->
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>


    </div>
  </div>
</div>

<ng-template #templateExit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد تایید لغو ماموریت </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Exit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> شماره حکم </label>
        <input [(ngModel)]="Exit_Schedule_Code" name="Exit_Schedule_Code" type="number" class="form-control"
          placeholder="اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> کد تایید </label>
        <input [(ngModel)]="Exit_Confirm_Code" name="Exit_Confirm_Code" type="number" class="form-control"
          placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="CodeChangeExit()" type="button" [disabled]="!Exit_Schedule_Code || !Exit_Confirm_Code"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Exit.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCalibrationStatus>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فعال سازی مجدد </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CalibrationStatus.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> شرح درخواست </label>
        <input [(ngModel)]="CalibrationStatus_Dsc" name="CalibrationStatus_Dsc" type="text" class="form-control"
          placeholder="اینجا تایپ کنید ...">
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button (click)="SubmitCalibrationStatus()" type="button" [disabled]="!CalibrationStatus_Dsc"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CalibrationStatus.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCustomer>

  <div class="modal-body">
    <app-CutomerView [inner_customer_id]="Selected_DataList_Customer.customerId">

    </app-CutomerView>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateLetterFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فایل های پیوست شده </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterFile.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <h6 class="modal-title" style="float: left;"> شماره نامه مشتری '{{LetterFile_Data_Code}}' </h6>
      <h6 class="modal-title" style="float: right;"> تاریخ نامه مشتری '{{LetterFile_Data_Tarikh}}' </h6>
      <div style="clear: both;"></div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>فایل</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of LetterFile_Data_List">
              <td>{{LetterFile_Data_List.indexOf(item)+1}}</td>
              <td>
                <a target="_blank" href="{{BaseUrlLetter}}File/Letter/{{item}}" class="btn btn-success"><i
                    class="fa fa-download"></i> مشاهده </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterFile.hide()">بستن</button>
  </div>
</ng-template>